export default __webpack_public_path__ + "static/media/Non_Gov.aeff6c72.svg";